import Layout from '@/layout/layout'

const financeOrderRouter = {
    path: '/financeOrder',
    component: Layout,
    redirect: 'noRedirect',
    name: '回收订单管理',
    children: [
        {
            path: 'index',
            component: () => import('@/views/financeOrder/index'),
            name: '订单列表(财务)',
            meta: {title: '订单列表(财务)', noCache: true}
        },
        {
            path: 'Details',
            component: () => import('@/views/financeOrder/Details'),
            name: '订单详情',
            meta: {title: '订单详情', noCache: true}
        },
    ]
}

export default financeOrderRouter
